/*
 * Senast visade produkter.
 *
 * Handles sparas i localStorage och renderas via Shopifys Search API, som
 * returnerar färdiga produktkort från temat. Ingen tredjepart, ingen cookie,
 * inget som lämnar webbläsaren.
 */

const SS_RV_KEY = 'ss:recently-viewed';
const SS_RV_MAX = 20;

function ssReadHistory() {
  try {
    const raw = window.localStorage.getItem(SS_RV_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    // Privat läge eller fullt lagringsutrymme — funktionen är inte kritisk.
    return [];
  }
}

function ssRemember(handle) {
  if (!handle) return;
  try {
    const next = [handle, ...ssReadHistory().filter((h) => h !== handle)].slice(0, SS_RV_MAX);
    window.localStorage.setItem(SS_RV_KEY, JSON.stringify(next));
  } catch {
    /* tyst — se ovan */
  }
}

class SsRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const current = this.dataset.currentHandle;
    const limit = parseInt(this.dataset.limit, 10) || 8;

    // Historiken läses innan den aktuella produkten läggs till, annars
    // skulle sidan alltid rekommendera sig själv.
    const history = ssReadHistory().filter((h) => h && h !== current);
    ssRemember(current);

    if (history.length === 0) return;

    const grid = this.querySelector('[data-ss-recently-viewed-grid]');
    if (!grid) return;

    const query = history
      .slice(0, limit)
      .map((h) => `handle:${h}`)
      .join(' OR ');

    try {
      const url = `${window.Shopify?.routes?.root || '/'}search?section_id=ss-recently-viewed-results&type=product&q=${encodeURIComponent(query)}`;
      const res = await fetch(url);
      if (!res.ok) return;

      const markup = new DOMParser().parseFromString(await res.text(), 'text/html');
      const cards = markup.querySelectorAll('[data-ss-card]');
      if (cards.length === 0) return;

      // Sortera tillbaka till besöksordning — sökresultat kommer i relevansordning.
      const byHandle = new Map();
      cards.forEach((card) => byHandle.set(card.dataset.ssCard, card));

      history.forEach((handle) => {
        const card = byHandle.get(handle);
        if (card) grid.appendChild(card);
      });

      if (grid.children.length > 0) this.hidden = false;
    } catch {
      /* nätverksfel — sektionen förblir dold */
    }
  }
}

if (!customElements.get('ss-recently-viewed')) {
  customElements.define('ss-recently-viewed', SsRecentlyViewed);
}
